import { Component, OnInit, Input } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AuthServiceService } from 'src/app/_services/AuthService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { ShareDataService } from 'src/app/_services/ShareData.service';

@Component({
  selector: 'app-emailproject',
  templateUrl: './emailproject.component.html',
  styleUrls: ['./emailproject.component.css']
})
export class EmailprojectComponent implements OnInit {

  isSaving = false;
  currentView = "emailconfigurations";


  @Input() currentProject: any;
  @Input() currentApiId: number;

  constructor(private _adminService: AdminServiceService, private _authService: AuthServiceService, private _alertify: AlertifyService, private _shareData: ShareDataService) { }

  ngOnInit() {
    this._shareData.currentViewSource.subscribe(view => {
      if (view) {
        if (this.currentProject.apiKey == view.key && (view.viewName == 'emailconfigurations' || view.viewName == 'emailtemplates'))
          this.currentView = view.viewName;
      }
    })
  } 

  onSave() {
    this.isSaving = true;

      this._adminService.addSubscription({
        "UserId": +this._authService.decodedToken.nameid,
        "APIId": this.currentApiId,
        "ProjectName": this.currentProject.projectShortName
      }).subscribe(data => {
        
        this.currentProject.id = data["id"];
        this.currentProject.apiKey = data["apiKey"];

        this._alertify.success("Subscription was created.");
        this.isSaving = false;
      }, error => {
        this._alertify.error(error);
        this.isSaving = false;
      });

  }

}
